import { IFilterQuery, TRANSFER_TYPE } from '@shared/types';
import { get, merge } from 'lodash';
import { toMoment } from '@shared/utils';

export const getTransferEventQueryFilter = (
  transferType: TRANSFER_TYPE,
): string => {
  const filterMap = {
    [TRANSFER_TYPE.PRE_EVENT_TRANSFER]: `(status eq 'pending') and (event_days/start_date_time gt ${toMoment()
      .utc()
      .milliseconds(0)
      .subtract(2, 'days')
      .toISOString()})`,
    [TRANSFER_TYPE.DURING_EVENT_TRANSFER]: `(status eq 'open')`,
  };

  return get(filterMap, transferType, '');
};

export const composeWithDefaultEventQuery = (
  userQuery: IFilterQuery,
): IFilterQuery => {
  return merge(
    {},
    {
      filter: '',
      select: [
        'name',
        'id',
        'availability_conditions',
        'event_days',
        'available_sites',
        'event_type_entity_id',
      ],
      orderby: 'name asc',
      include_available_sites: true,
      available_sites_select: 'name,store_number,type,metadata',
      include_inactive: false,
    },
    userQuery,
  );
};

export const getPreEventTransactionDateRange = (
  companyCurrentDate: string,
  salesStartDate: string,
): { maximum: string; minimum: string } => {
  const isSalesStartTimeBeforeCurrentTime = toMoment(salesStartDate).isBefore(
    toMoment(companyCurrentDate),
  );

  if (isSalesStartTimeBeforeCurrentTime) {
    return {
      minimum: salesStartDate,
      maximum: companyCurrentDate,
    };
  }

  return {
    minimum: companyCurrentDate,
    maximum: salesStartDate,
  };
};
